import { render, staticRenderFns } from "./AdFormPromotionLine.vue?vue&type=template&id=2f10ec22"
import script from "./AdFormPromotionLine.vue?vue&type=script&lang=ts"
export * from "./AdFormPromotionLine.vue?vue&type=script&lang=ts"
import style0 from "./AdFormPromotionLine.vue?vue&type=style&index=0&id=2f10ec22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports